import Vue from 'vue'
import Module from './one_module'
import $store from '../store/index'
import utils from '@/base/utils'
import { mydebounce } from '@/base/debounce'
import create_default_data from '@/base/default_data'
import create_poster_template from '@/base/posterTemplate'

// 新增需求新加字段
var selectTemplateType = ''
export default class Person_base extends Vue {
  constructor() {
    super()
    //  全屏组件
    this.full_widgets = ['lock', 'fingerprint', 'wipe', 'chat']
    // 屏幕宽度
    this.screenWidth = document.documentElement.clientWidth || document.body.clientWidth

    // 屏幕高度
    this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight

    this.mydebounce = mydebounce(e => {
      this.Stack(e)
    }, 500)

    this.auto_save_debounce = mydebounce(e => {
      this.auto_save()
    }, 1000)
  }

  moudle_draggable_methods(dom) {
    const that = this
    var click = {
        x: 0,
        y: 0
      };
    dom.draggable({
        
      // containment: '.center_frame',
      grid: [1, 1],
      start: function(event, ui) {
        click.x = event.clientX;
          click.y = event.clientY;
        const select_module = $store.state.widgets.select_module
        const tid = $(this).attr('id').replace('u', '')
        if (select_module.length <= 1) {
          that.aline_start(that, $(this), '.center_module_edit')
        }

        // 多选的情况下，要判断移动的是不是在选中集合中
        const noHave = that.select_module_has(tid)
        if (select_module.length > 0 && noHave) {
          $store.commit('widgets/CLEAR_select_module')
        }

        // 加入选中挂件队列
        const module = that.p_find_module(tid)
        const isSelectOneModuleInGroup =
          module && module.gid && $store.state.widgets.module_Data && module.tid === $store.state.widgets.module_Data.tid

        if (module) {
          $store.commit('widgets/ADD_select_module', module)
        }

        if (module && module.gid && !isSelectOneModuleInGroup) {
          const modules = $store.state.body.data.pages.cmps.filter(item => {
            return item.gid === module.gid && module.tid !== item.tid
          })
          modules.forEach(item => {
            $store.commit('widgets/ADD_select_module', item)
          })
        }
        $store.state.align.modules_size = that.screen_line_align_start()
        that.all_module_draggable_start(event, ui, $(this))
      },
      drag: function(event, ui) {
        // 对齐线逻辑
        var dragLeft = $(this).offset().left
        var dragTop = $(this).offset().top

        var moveLeft = ui.offset.left
        var moveTop = ui.offset.top

        var dragWidth = $(this).width()
        var dragHeight = $(this).height()
        // const scale = 1;

        // 指针偏移问题修复
        var zoom = $store.state.auxiliary_toolbar.scale
        var original = ui.originalPosition;
        ui.position = {
            top:  (event.clientY - click.y + original.top ) / zoom,
            left: (event.clientX - click.x + original.left) / zoom,
        };
        that.all_module_draggable_drag(event, ui)

        if ($store.state.widgets.select_module.length <= 1) {
          that.aline_drag(null, $(this), dragLeft, dragTop, dragWidth, dragHeight, moveLeft, moveTop, true)
        }

        that.screen_line_align_move(moveLeft, moveTop, $(this))
      },
      stop: function(event, ui) {
        const left = Math.round(parseFloat($(this).css('left')))
        const top = Math.round(parseFloat($(this).css('top')))
        // 拖拽结束，从视图获取位置，设置数据层
        that.all_module_draggable_end(event, ui)

        // 对齐线逻辑
        if ($store.state.align.lock.transverse_lock) {
          $(this).css('left', left)
        }
        if ($store.state.align.lock.vertical_lock) {
          $(this).css('top', top)
        }
        that.p_remove_line()
        that.p_remove_lock()
        $store.commit('clear_targetDom') // 清除数组，减少内存消耗
        $store.commit('clear_modules_size') // 清除重置

        // 在多选模式下拖拽移动

        if ($store.state.widgets.select_module.length > 1) {
          $store.commit('widgets/SET_selection_move', true)
        }
      }
    })
    $(dom).mouse({
      cancel: '.my-text-wrapper,.rich-content'
    })
  }

  // 批量选中module，一起拖拽
  all_module_draggable_start(event, ui, $this) {
    // 先重置
    $store.commit('widgets/CLEAR_move_position')
    const this_id = $this.attr('id').replace('u', '')
    // const scale = 1;
    $store.state.widgets.move_position.top = ui.position.top
    $store.state.widgets.move_position.left = ui.position.left
    // console.log(ui.position.top,ui.position.left)
    $store.state.widgets.move_position.id = this_id
  }

  // 批量选中module，一起拖拽
  all_module_draggable_drag(event, ui) {
    // debugger
    const scale = 1
    // 当前拖拽挂件的新位置
    const this_module_top = ui.position.top
    const this_module_left = ui.position.left
    // 当前移动的位置和开始移动的差值
    const position_top_diff = this_module_top - $store.state.widgets.move_position.top
    const position_left_diff = this_module_left - $store.state.widgets.move_position.left

    const select_module = $store.state.widgets.select_module
    for (let i = 0; i < select_module.length; i++) {
      if (select_module[i].tid !== $store.state.widgets.move_position.id && !select_module[i].lock) {
        // 当前正在拖拽的那个，不改变位置
        $(`#u${select_module[i].tid}`).css({
          top: select_module[i].style.top + position_top_diff / scale + 'px',
          left: select_module[i].style.left + position_left_diff / scale + 'px'
        })
      }
    }
  }

  // 批量选中module，一起拖拽
  all_module_draggable_end(event, ui) {
    const select_module = $store.state.widgets.select_module
    for (let i = 0; i < select_module.length; i++) {
      if (!select_module[i].lock) {
        const top = parseInt($(`#u${select_module[i].tid}`).css('top'))
        const left = parseInt($(`#u${select_module[i].tid}`).css('left'))
        select_module[i].style.top = top
        select_module[i].style.left = left
      }
    }
  }

  // 新增挂件
  add_module(cmpType, params = {}, is_fixed = false, type) {
    $store.state.widgets.is_first_add_module = true
    const widgets = this.get_widgets() //  返回当前选中页面的所有挂件
    const module = this.create_one_module(cmpType, params)
    if (!is_fixed) {
      this.add_moduleTo_center(module, params)
    }
    if (cmpType === 'image') module.imgType = type
    const pages = $store.state.body.data.pages
    //  由于全屏组件要求默认置顶，故需要作特殊处理
    if (!this.full_widgets.includes(module.cmpType)) {
      if (this.has_full() !== null) {
        //  在全屏组件前面插入挂件，越往后，层级越高
        widgets.splice(this.has_full(), 0, module)
      } else {
        //  添加到当前页面的挂件列表中。由于 Vuex 的状态存储是响应式的，所以会更新到store中，但是应该使用mutations来更新便于维护与追踪状态变化。
        if(selectTemplateType == 'detail') {
            var topValue = module.style?.top ? module.style.top: module._style.top
            console.log(topValue,'topValue')
            if(!module.style.top) {
                module.style.top = module._style.top
                module.style.left = module._style.left
            }
            if(topValue < pages.headerConfig.style.height) {
                // 拖入头部
                console.log('拖入头部')
                module.areaType = 'header'
                pages.headerConfig.cmps.push(module)
            } else if(pages.headerConfig.style.height < topValue  && topValue < (pages.headerConfig.style.height + pages.bodyConfig.style.height)) {
                // 拖入中间部分
                // module.style.top = module.style.top - pages.headerConfig.style.height // 减去头部的高度
                // module.areaType = 'body'
                // widgets.push(module)
                console.log('拖入中间部分')
                return
            } else if((pages.headerConfig.style.height + pages.bodyConfig.style.height) < topValue &&  topValue < $('.edit_preview_frame').height() ) {
                // 拖入底部
                console.log('拖入底部')
                module.style.top = topValue - pages.headerConfig.style.height - (pages.bodyConfig.style.height+20) // 减去头部的高度
                module.areaType = 'footer'
                pages.footerConfig.cmps.push(module)
            }
        } else {
            if(module._style.top) {
                module.style.top = module._style.top
                module.style.left = module._style.left
            }
            widgets.push(module)
        }
       
      }
    } else {
      //  添加到当前页面的挂件列表中。由于 Vuex 的状态存储是响应式的，所以会更新到store中，但是应该使用mutations来更新便于维护与追踪状态变化。
      widgets.push(module)
    }
    this.$nextTick(() => {
      this.select_one_module(module)
      $store.state.widgets.is_first_add_module = false
    })
  }
  //  判断是否有全屏挂件，并返回在widgets中的索引
  has_full() {
    const widgets = this.get_widgets() //  返回当前选中页面的所有挂件
    let index = null
    for (let i = 0; i < widgets.length; i++) {
      if (this.full_widgets.includes(widgets[i].cmpType)) {
        index = i
        break
      }
    }
    return index
  }

  // 创建挂件
  create_one_module(cmpType, params = {}) {
    const widgets = this.get_widgets()
    const PendantObj = $store.state.widgets.PendantObj
    const module = new Module({
      tid: this.create_id(),
      cmpType,
      name: PendantObj[cmpType].name + (widgets.length + 1)
    })
    const _module = {
      ...module,
      ...params
    }
    const text = $store.state.options.textList.find(val => val.value === params.textType)
    if (text && text.label) _module.text = text.label
    _module.positionInfoList = [] // 职位信息
    console.log(module, params, '_module')
    if (cmpType === 'text') {
      _module.style = {
        ...module.style,
        ...params._style
      }
      delete module._style
    }
    console.log('🚀 ~ file: public.js ~ line 212 ~ Person_base ~ create_one_module ~ _module', _module)
    return _module
  }

  // 挂件新增到屏幕中间
  add_moduleTo_center(module, params) {
    var isDrag = false
    if(!params.textType && params._style && params._style.top) {
        isDrag = true // 自定义组件赋值
    }
    const data = $store.state.body.data
    const s_w = data.width
    const s_h = data.height
    let m_w = module.style.width
    let m_h = module.style.height
    if (module.cmpType === 'text') {
      m_h = module.style['line-height']
    } else if (module.cmpType === 'gchoose') {
      m_h = 165
    } else if (module.cmpType === 'praise') {
      m_w = 70
      m_h = 50
    }
    const l = (s_w - m_w) / 2
    const t = (s_h - m_h) / 2
    module.style.top = isDrag? params._style.top: t
    module.style.left = isDrag? params._style.left: l
  }

  // 获取当前选中页面的挂件列表
  get_widgets() {
    let widgets = []
    const index = $store.state.body.current_page_index
    const pages = $store.state.body.data.pages
    //  if (pages[index] && pages[index].cmps && pages[index].cmps instanceof Array) {
    //    widgets = pages[index].cmps;
    //  }
    if (Array.isArray(pages?.cmps)) {
      widgets = pages.cmps
    }
    return widgets
  }

  // 查找挂件
  p_find_module(id) {
    var widgets = this.get_widgets()
    let obj = null
    const pages = $store.state.body.data.pages
    if(selectTemplateType == 'detail') {
        widgets = [...widgets,...pages.headerConfig.cmps,...pages.footerConfig.cmps]
    }
    const index = this.p_find_module_index(id)
    if (index !== null) {
      obj = widgets[index]
    }
    return obj
  }

  // 查找挂件的index
  p_find_module_index(id) {
    var widgets = this.get_widgets()
    const pages = $store.state.body.data.pages
    if(selectTemplateType == 'detail') {
        widgets = [...widgets,...pages.headerConfig.cmps,...pages.footerConfig.cmps]
    }
    let index = null
    for (let i = 0; i < widgets.length; i++) {
      if (widgets[i].tid === id) {
        index = i
      }
    }
    return index
  }

  // 删除挂件
  p_delect_module(id) {
    const widgets = this.get_widgets()
    const index = this.p_find_module_index(id)
    if (index !== null) {
      widgets.splice(index, 1)
      $store.commit('widgets/SET_module_Data', null)
    }
  }

  getTemplateData() {
    // 获取模板数据
    return create_poster_template()
  }

  
  // 数据过滤，所有页面加入tid
  data_init($this, type, data) {
    $store.commit('widgets/SET_init_loading', true)
    const templateId = $this.$route.query.templateId
    const id = $this.$route.query.id || templateId
    // const role = $this.$route.query.role || 'works'
    const pattern = $this.$route.query.pattern || ''
    // $store.commit('widgets/SET_role', role)
    $store.commit('widgets/SET_save_pattern', pattern)
    const templateType = $this.$route.query.type || type
    selectTemplateType = templateType
    const templateData = create_poster_template()
    if (type === 'create') {
      const data = create_default_data()
      $store.commit('body/SET_data', data)
    } else if (data) {
      // 来自于接口的模板
      $store.commit('body/SET_data', data)
    } else if (templateType) {
      // 设置默认模板
      console.log(templateData[templateType], 'templateData[templateType]')
      $store.commit('body/SET_data', templateData[templateType])
    }
    $store.commit('widgets/SET_init_loading', false)
    // 设置全局id
    // if (id) {
    //   !templateId && $store.commit('widgets/SET_theme_id', id)
    //   // 请求详情
    //   this.get_data_detail(templateId)
    // } else {
    //   // 如果没有id。就是空模板
    //   const data = create_default_data()
    //   $store.commit('body/SET_data', templateData[templateType])
    //   $store.commit('widgets/SET_init_loading', false)
    // }

    //  bin 修改 2.21 没有id 调用保存
    if (!id && pattern !== 'page') {
      //  this.p_save({ needToast: false });
    }
  }

  get_data_detail(templateId) {
  }

  info_data_init(data, info) {
    for (const key in info) {
      console.log(key)
      if (typeof data[key] !== 'undefined') {
        info[key] = data[key]
      }
    }
  }

  data_filter(my_data) {
    const pages = my_data.pages
    if (pages) {
      if (!pages.id) {
        pages.id = this.create_id()
      }
      if (pages.cmps && pages.cmps instanceof Array) {
        this.module_filter(pages.cmps)
      }
    }
    utils.fixTemplateData(my_data) // 数据过滤
    this.processHistoryDeviceData(my_data)

    $store.commit('body/SET_data', my_data)
  }

  needDefault(data) {
    // return !$store.state.options.device.find(d => d.value === data.device)
  }

  processHistoryDeviceData(data) {
  }

  // 挂件过滤
  module_filter(modules) {
    for (let j = 0; j < modules.length; j++) {
      const module = modules[j]
      if (!module.tid) {
        module.tid = this.create_id()
      }
      if (typeof module.lock === 'undefined') {
        module.lock = false
      }
      if (typeof module.hidden === 'undefined') {
        module.hidden = false
      }
    }
  }

  create_id(length = 8) {
    const end = utils.create_id()
    return end
  }

  /*
   * 对齐线，放到开始拖拽里的
   * that:使用方法的vue对象
   * $this：当前拖拽的元素
   * */
  aline_start(that, $this, dom) {
    // 一开始拖拽的时候，就把同屏幕的dom找出来
    var thisId = $this.attr('id')
    var srcollTop = $(window).scrollTop() // 窗口卷去高度
    var moduleArr = $(dom)
    // that.targetDom = [];
    $store.commit('clear_targetDom')

    // 在刚开始拖拽的时候，找出屏幕范围内，所有的方块，把它们的信息插入到一个数组中，在拖拽时，就遍历这个数组，而不是遍历所有的dom,在100个左右的dom情况下，性能会更好
    for (var i = 0; i < moduleArr.length; i++) {
      var moduleHeight = moduleArr.eq(i).height() // 每个方块的高度
      var moduleTop = moduleArr.eq(i).offset().top // 每个方块距离文档顶部的距离
      var screenTop = moduleTop - srcollTop // 每个方块距离屏幕顶部的距离
      var module_id = moduleArr.eq(i).attr('id')
      // 记录每个方块的信息，用于遍历计算
      var module_data = {
        id: module_id,
        width: moduleArr.eq(i).width(),
        height: moduleHeight,
        top: moduleTop,
        left: moduleArr.eq(i).offset().left
      }

      // module的对齐线
      if (dom === '.center_module_edit') {
        // 在当前屏幕范围内的方块，去除拖拽的那个
        if (screenTop + moduleHeight > 0 && screenTop < this.screenHeight && module_id !== thisId) {
          $store.commit('add_targetDom', module_data)
        }
      } else {
        const dom_i = $this.index()
        if (i !== dom_i) {
          $store.commit('add_targetDom', module_data)
          // that.targetDom.push(module_data);
        }
      }
    }
  }

  // 删除线
  p_remove_line() {
    if ($('.align_line').length > 0) {
      $('.align_line').remove()
    }
  }

  /*
   * 对齐线，放到正在拖拽里的
   * */
  aline_drag(that, $this, dragLeft, dragTop, dragWidth, dragHeight, moveLeft, moveTop, isLock) {
    // 移动开始前，先清除线
    this.p_remove_line()
    // console.log(dragLeft,dragTop);
    const lines = $store.state.align.targetDom

    // 当前拖拽元素对比别的元素的对齐线
    for (var i = 0; i < lines.length; i++) {
      var target_left = lines[i].left
      var target_top = lines[i].top
      var target_width = lines[i].width
      var target_height = lines[i].height

      // 10种可能的对齐线
      // 拖拽元素的左边，与目标元素的左边一致,就只有一根线
      if (
        dragLeft > target_left - $store.state.align.Error_amount &&
        dragLeft < target_left + $store.state.align.Error_amount
      ) {
        $store.commit('lock_transverse_true')
        // that.lock.transverse_lock = true; // 横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft)
      }
      // 拖拽元素的左边，与目标元素的右边一致,就只有一根线
      if (
        dragLeft > target_left + target_width - $store.state.align.Error_amount &&
        dragLeft < target_left + target_width + $store.state.align.Error_amount
      ) {
        $store.commit('lock_transverse_true')
        // that.lock.transverse_lock = true; // 横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft)
      }
      // 中间的竖向对齐线
      if (
        dragLeft + dragWidth / 2 > target_left + target_width / 2 - $store.state.align.Error_amount &&
        dragLeft + dragWidth / 2 < target_left + target_width / 2 + $store.state.align.Error_amount
      ) {
        $store.commit('lock_transverse_true')
        // that.lock.transverse_lock = true; // 横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft + dragWidth / 2)
      }
      // 拖拽元素的右边，与目标元素的右边一致,就只有一根线
      if (
        dragLeft + dragWidth > target_left + target_width - $store.state.align.Error_amount &&
        dragLeft + dragWidth < target_left + target_width + $store.state.align.Error_amount
      ) {
        $store.commit('lock_transverse_true')
        // that.lock.transverse_lock = true; // 横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft + dragWidth)
      }
      // 拖拽元素的右边，与目标元素的左边一致,就只有一根线
      if (
        dragLeft + dragWidth > target_left - $store.state.align.Error_amount &&
        dragLeft + dragWidth < target_left + $store.state.align.Error_amount
      ) {
        $store.commit('lock_transverse_true')
        // that.lock.transverse_lock = true; // 横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft + dragWidth)
      }

      // 拖拽元素的上边，与目标元素的上边一致,就只有一根线
      if (
        dragTop > target_top - $store.state.align.Error_amount &&
        dragTop < target_top + $store.state.align.Error_amount
      ) {
        $store.commit('lock_vertical_true')
        // that.lock.vertical_lock = true; // 竖向锁定
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop)
      }
      // 拖拽元素的上边，与目标元素的下边一致,就只有一根线
      if (
        dragTop > target_top + target_height - $store.state.align.Error_amount &&
        dragTop < target_top + target_height + $store.state.align.Error_amount
      ) {
        $store.commit('lock_vertical_true')
        // that.lock.vertical_lock = true; // 竖向锁定
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop)
      }
      // 中间的竖向对齐线
      if (
        dragTop + dragHeight / 2 > target_top + target_height / 2 - $store.state.align.Error_amount &&
        dragTop + dragHeight / 2 < target_top + target_height / 2 + $store.state.align.Error_amount
      ) {
        $store.commit('lock_vertical_true')
        // that.lock.vertical_lock = true; // 竖向锁定
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop + dragHeight / 2)
      }

      // 拖拽元素的下边，与目标元素的下边一致,就只有一根线
      if (
        dragTop + dragHeight > target_top + target_height - $store.state.align.Error_amount &&
        dragTop + dragHeight < target_top + target_height + $store.state.align.Error_amount
      ) {
        // that.lock.vertical_lock = true; // 竖向锁定
        $store.commit('lock_vertical_true')
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop + dragHeight)
      }

      // 拖拽元素的下边，与目标元素的上边一致,就只有一根线
      if (
        dragTop + dragHeight > target_top - $store.state.align.Error_amount &&
        dragTop + dragHeight < target_top + $store.state.align.Error_amount
      ) {
        $store.commit('lock_vertical_true')
        // that.lock.vertical_lock = true; // 竖向锁定
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop + dragHeight)
      }
    }
    if (isLock) {
      this.p_lock(moveLeft, moveTop, $this, that)
    }
  }

  /*
   * 竖向一根对齐线
   * target_top:目标元素的top
   * target_height:目标元素的height
   * dragTop:拖拽元素的top
   * dragHeight:拖拽元素的height
   * dragLeft:拖拽元素的left
   * dragLeft:拖拽元素的left
   * lineLeft：竖向对齐线的left值
   * */
  left_right_line(target_top, target_height, dragTop, dragHeight, lineLeft) {
    // 如果目标方块在拖拽方块上面
    if (target_top < dragTop) {
      this.p_create_line({
        type: 'vertical',
        size: dragTop + dragHeight - target_top + 20,
        top: target_top - 10,
        left: lineLeft
      })
    } else {
      this.p_create_line({
        type: 'vertical',
        size: target_top + target_height - dragTop + 20,
        top: dragTop - 10,
        left: lineLeft
      })
    }
  }

  /*
   * 横向向一根对齐线
   * */
  top_bottm_line(dragLeft, dragWidth, target_left, target_width, lineLeft) {
    // 如果目标方块在拖拽方块左面
    if (target_left < dragLeft) {
      // debugger;
      this.p_create_line({
        type: 'transverse',
        size: dragLeft + dragWidth - target_left + 20,
        top: lineLeft,
        left: target_left - 10
      })
    } else {
      this.p_create_line({
        type: 'transverse',
        size: target_left + target_width - dragLeft + 20,
        top: lineLeft,
        left: dragLeft - 10
      })
    }
  }

  p_create_line(param) {
    const type = param.type
    const size = param.size
    const top = param.top
    const left = param.left

    var line = $('<div class="align_line"></div>')
    // var line = $('.align_line')
    // type代表是横线还是竖线
    if (type === 'transverse') {
      line.css({
        width: size + 'px',
        height: '1px',
        top: top,
        left: left
      })
    } else {
      line.css({
        width: '1px',
        height: size + 'px',
        top: top,
        left: left
      })
    }
    line.appendTo('body')
  }

  p_lock(moveLeft, moveTop, self, that) {
    // console.log(dragTop);
    // 竖向锁定了
    if ($store.state.align.lock.vertical_lock) {
      const module_offset_Top = self.offset().top // 拖拽元素距离文档顶部的距离
      // 插入锁定标签
      if ($('.lock_top_style').length === 0) {
        // 批量锁定

        this.module_locks('top')
      }
      if (
        moveTop < module_offset_Top - $store.state.align.Error_lock ||
        moveTop > module_offset_Top + $store.state.align.Error_lock
      ) {
        $store.commit('lock_vertical_false')
        // that.lock.vertical_lock = false;
        this.p_remove_line()
        this.p_remove_lock()
      }
    }

    // 横向锁定了
    if ($store.state.align.lock.transverse_lock) {
      // console.log(123);
      const module_offset_Left = self.offset().left // 拖拽元素距离文档顶部的距离
      // 插入锁定标签
      if ($('.lock_left_style').length === 0) {
        // const lock_left_style = $(`<style class="lock_left_style">#${moduleId} {left:${module_Left}px !important;}</style>`);
        // lock_left_style.appendTo('head');
        // 批量锁定
        this.module_locks('left')
      }
      // debugger;
      if (
        moveLeft < module_offset_Left - $store.state.align.Error_lock ||
        moveLeft > module_offset_Left + $store.state.align.Error_lock
      ) {
        $store.commit('lock_transverse_false')
        // that.lock.transverse_lock = false;
        this.p_remove_line()
        this.p_remove_lock()
      }
    }
  }
  // 删除锁定元素
  p_remove_lock() {
    if ($('.lock_top_style').length > 0) {
      $('.lock_top_style').remove()
    }

    if ($('.lock_left_style').length > 0) {
      $('.lock_left_style').remove()
    }
  }

  // 挂件缩放
  moudle_resizable_methods(dom) {
    const that = this
    // let aspectRatio = false
    const cmpType = dom.parents('.module').attr('cmptype')
    if (cmpType === 'image' || cmpType === 'shape' || cmpType === 'video' || cmpType === 'text') {
    //   aspectRatio = true
    }
    let handles = 'n, e, s, w, ne, se, sw, nw'
    if (cmpType === 'text') {
      handles = 'e, w, ne, se, sw, nw'
    }
    dom.resizable({
      autoHide: true,
      handles: handles,
      minHeight: 12,
      // aspectRatio,
      resize: function(event, ui) {
        const id = $(this).parent('.module').attr('id').replace('u', '')
        const module = that.p_find_module(id)

        const width = ui.size.width
        const height = ui.size.height

        if (module) {
          module.style.width = width
          module.style.height = height

          if (module.cmpType === 'image') {
            const border_width = module.style['border-width']
            let num = 0
            if (border_width) num = border_width
            module.style.width = width - num * 2
            module.style.height = height - num * 2
          }

          if (module.cmpType === 'text') {
            // 获取元素文字所占高度
            const dom_height = dom.children('.basic_text').children('.my-text-wrapper').height()

            // 如果是左右拖拽就不能改变大小
            if (!module.canResize) {
              module.style['height'] = dom_height
              return
            }

            // 先获取当前有多少行文字
            let words_line_num = Math.round(dom_height / module.style['line-height'])

            words_line_num = words_line_num < 1 ? 1 : words_line_num

            // 记录最后的行高，避免行高突变
            const last_line_height = module.style['line-height']

            const border_width = module.style['border-width']
            let num = 0
            if (border_width) num = border_width

            // let use_height = height > dom_height ? dom_height : height
            // 实际计算行高 => （高度- 2倍数边宽）/ 文字行数
            const need_line_height = parseInt((height - num * 2) / words_line_num)
            // 高度突变，应该是行数变化导致，不应该处理行高
            if (last_line_height - need_line_height > 10 || need_line_height - last_line_height > 10) {
              module.style['line-height'] = last_line_height
            } else {
              module.style['line-height'] = need_line_height
            }

            module.style['height'] = module.style['line-height'] * words_line_num + num * 2
            module.style['font-size'] = parseInt(module.style['line-height'] / 1.3)
          }
        }
      },
      start: function(event, ui) {
        //  const helper = $(event.toElement);
        //  if(helper.hasClass('ui-resizable-se')){
        //    dom.resizable( "option", "aspectRatio", true );
        //  }
        //  else{
        //    dom.resizable( "option", "aspectRatio", false );
        //  }

        const id = $(this).parent('.module').attr('id').replace('u', '')
        const module = that.p_find_module(id)
        console.log(module,'modulemodulemodule')
        // event.toElement.classList 不兼容火狐
        if (event.originalEvent && event.originalEvent.target && event.originalEvent.target.classList) {
          // 获取拖拽元素的类名
          const classList = event.originalEvent.target.classList

          // 标记是否是左右拖拽
          if (
            classList[0] === 'ui-resizable-handle' &&
            (classList[1] === 'ui-resizable-e' || classList[1] === 'ui-resizable-w')
          ) {
            module.canResize = false
          } else {
            module.canResize = true
          }
        } else {
          module.canResize = true
        }
      },
      stop: function(event, ui) {
        // 如果是左边的3个点，则要重新计算一下位置
        const module = $(this).parents('.module')
        const b_t = parseFloat($(this).css('top'))
        const b_l = parseFloat($(this).css('left'))
        const m_t = parseFloat(module.css('top'))
        const m_l = parseFloat(module.css('left'))
        const end_t = m_t + b_t
        const end_l = m_l + b_l
        const tid = module.attr('id').replace('u', '')
        const module_data = that.p_find_module(tid)
        module_data.style.top = end_t
        module_data.style.left = end_l
        module.css({
          left: end_l + 'px',
          top: end_t + 'px'
        })

        if (module_data.cmpType === 'lantern') {
          module_data.style.width = 320
          module_data.style.height = 410
        }

        $(this).css({
          width: '100%',
          height: '100%',
          top: 0,
          left: 0
        })
      }
    })
  }

  // 挂件选中
  module_selectable() {
    const that = this
    $('.center_selectable_frame').selectable({
      appendTo: '#app',
      tolerance: 'touch',
      filter: '.center_module_edit',
      start: function() {},
      selecting: function(event, ui) {
        const id = $(ui.selecting).attr('id').replace('u', '')
        const module = that.p_find_module(id)
        if (module) {
          $store.commit('widgets/ADD_select_module', module)
        }
      },
      unselecting: function(event, ui) {
        const id = $(ui.unselecting).attr('id').replace('u', '')
        $store.commit('widgets/DEL_select_module', id)
      },
      stop: function(event, ui) {
        // 多选放开后，根据当前的顺序重新排序一下
        const select_module = $store.state.widgets.select_module
        const widgets = that.get_widgets()
        const r = []
        console.log(select_module, 'select_module')
        for (let i = 0; i < widgets.length; i++) {
          for (let j = 0; j < select_module.length; j++) {
            if (widgets[i].tid === select_module[j].tid) {
              r.push(select_module[j])
              break
            }
          }
        }
        $store.state.widgets.select_module = r
      }
    })
  }

  contextmenu_position(e) {
    const h = $('.fk-projectContextMenu').height() + 10
    const w = $('.fk-projectContextMenu').width() + 10
    const box_h = $(window).height()
    const box_w = $(window).width()
    let x = e.clientX
    let y = e.pageY
    const radio = $store.state.widgets.zoom_ratio
    if (box_h - e.clientY <= h) {
      y = e.pageY - h
      if (y < 0 && radio > 100) y = Math.abs(y) // 小屏幕兼容调试
    }

    //  y = e.pageY - 200

    if (y < 0) {
      y = 0
    }

    x = x + 10
    if (box_w - e.clientX <= w) {
      x = e.clientX - w
    }
    return { x, y }
  }

  // 选中队列中是否存在
  select_module_has(tid) {
    let noHave = true
    const select_module = $store.state.widgets.select_module
    for (let i = 0; i < select_module.length; i++) {
      if (select_module[i].tid === tid) {
        noHave = false
        break
      }
    }
    return noHave
  }

  create_module_length(cmpType) {
    let num = 0
    const widgets = this.get_widgets()
    for (let i = 0; i < widgets.length; i++) {
      if (widgets[i].cmpType === cmpType) {
        num++
      }
    }
    return num
  }

  copy_module() {
    // 复制的时候不能断开引用，保证黏贴的时候是最新的状态
    const copy_obj = $store.state.widgets.select_module.filter(m => !m.lock)
    const modules = []
    console.log(955, modules)

    var widgets = this.get_widgets()
    const pages = $store.state.body.data.pages
    if(selectTemplateType == 'detail') {
        widgets = [...widgets,...pages.headerConfig.cmps,...pages.footerConfig.cmps]
    }
    for (let i = 0; i < widgets.length; i++) {
      for (let j = 0; j < copy_obj.length; j++) {
        if (widgets[i].tid === copy_obj[j].tid) {
          modules.push(copy_obj[j])
          break
        }
      }
    }

    $store.commit('widgets/SET_copy_obj', modules)
  }

  paste_module() {
    // 黏贴的时候要断开引用关系，生成新的副本
    //  const modules = JSON.parse(JSON.stringify($store.state.contextmenu_dialog.copy_obj));
    const widgets = this.get_widgets()
    const PendantObj = $store.state.widgets.PendantObj
    const has_submit = this.templet.has_submit()

    // bin 调整组件顺序
    const modules = JSON.parse(JSON.stringify($store.state.widgets.copy_obj))

    const isGroup = modules[0]?.gid
    if (isGroup) {
      const gid = utils.create_id()
      modules.forEach(m => {
        m.gid = gid
      })
    }
    if (modules.length > 0) {
      // 修改复制队列
      for (let i = 0; i < modules.length; i++) {
        //  const otid = modules[i].tid;//  查找老的 tid
        modules[i].tid = this.create_id()
        const cmpType = modules[i].cmpType
        modules[i].lock = false
        modules[i].name = PendantObj[cmpType].name + (widgets.length + 1)
        if (modules[i].style) {
          if (!this.full_widgets.includes(modules[i].cmpType)) {
            modules[i].style.top = modules[i].style.top + 10
            modules[i].style.left = modules[i].style.left + 10
          }
        }

        // 提交按钮，如果当前页面已经有了，就不能再加了
        //  if(modules[i].cmpType !== "gsubmit" || (modules[i].cmpType === "gsubmit" && !has_submit)){
        //    widgets.push(modules[i]);
        //  }
        if (
          (modules[i].cmpType === 'dial' && has_submit.has_submit('dial')) ||
          (modules[i].cmpType === 'dialNew' && has_submit.has_submit('dialNew')) ||
          (modules[i].cmpType === 'grid' && has_submit.has_submit('grid')) ||
          (modules[i].cmpType === 'gridNew' && has_submit.has_submit('gridNew')) ||
          (modules[i].cmpType === 'goldenEgg' && has_submit.has_submit('goldenEggNew')) ||
          (modules[i].cmpType === 'gsubmit' && has_submit.has_submit('gsubmit')) ||
          (modules[i].cmpType === 'praise' && has_submit.has_submit('praise')) ||
          (this.full_widgets.includes(modules[i].cmpType) && this.has_full() !== null)
        ) {
          const name = $store.state.widgets.PendantObj[modules[i].cmpType].name
          this.$message({
            message: '每个页面只能加一个' + name,
            type: 'warning'
          })
        } else {
          //  粘贴时也要保证全屏组件置顶
          if (this.has_full() !== null) {
            widgets.splice(this.has_full(), 0, modules[i])
          } else {
            
            if(selectTemplateType == 'detail' && modules[i].areaType != 'body') {
                const pages = $store.state.body.data.pages
                if(modules[i].areaType == 'header') {
                    pages.headerConfig.cmps.push(modules[i])
                } else if(modules[i].areaType == 'footer') {
                    pages.footerConfig.cmps.push(modules[i])
                }
            } else if(selectTemplateType != 'detail' ){
                widgets.push(modules[i])
            }
          }
          //  const index = this.p_find_module_index(otid);
          //  if(index > -1){
          //    widgets.splice(index+1,0,modules[i])
          //  }else{
          //    widgets.push(modules[i]);
          //  }
        }
      }
    }

    // 插入完毕，如果黏贴的是一个挂件，则选中这个挂件
    if (modules.length === 1) {
      this.select_one_module(modules[0])
    } else if (modules.length > 1) {
      // 如果是多个，则清楚多选队列，插入新挂件
      $store.commit('widgets/CLEAR_select_module')
      for (let i = 0; i < modules.length; i++) {
        $store.commit('widgets/ADD_select_module', modules[i])
      }
    }
  }

  // 根据多选队列进行删除
  select_module_delect() {
    $store.commit('widgets/SET_module_Data', null)
    const select_module = $store.state.widgets.select_module
    const pages = $store.state.body.data.pages
    for (let i = 0; i < select_module.length; i++) {
      const index = this.p_find_module_index(select_module[i].tid)
      if (!select_module[i].lock) {
        const widgets = this.get_widgets()
        if(selectTemplateType == 'detail' && select_module[i].areaType !='body') {
            var headerIndex = pages.headerConfig.cmps.findIndex(val => val.tid == select_module[i].tid)
            var footerIndex = pages.footerConfig.cmps.findIndex(val => val.tid ==  select_module[i].tid)
            if(headerIndex > -1)pages.headerConfig.cmps.splice(headerIndex, 1)
            if(footerIndex > -1)pages.footerConfig.cmps.splice(footerIndex, 1)
        } else {
            widgets.splice(index, 1)
        }
      }
    }
    // 清除当前选中队列
    $store.commit('widgets/CLEAR_select_module')
  }

  // 选中一个挂件的逻辑
  select_one_module(module) {
    // 清除当前选中队列
    $store.commit('widgets/CLEAR_select_module')

    // 把当前挂件加入前选中队列
    $store.commit('widgets/ADD_select_module', module)

    // if(module.lock) return;

    $store.commit('module_edit/SET_show', true)

    // 挂件加入编辑
    $store.commit('widgets/SET_module_Data', module)
  }

  cut_module() {
    // 先复制
    this.copy_module()

    // 删除当前选中
    this.select_module_delect()
  }

  Stack(name = '') {
    const historical_records = $store.state.historical_records
    const Stack = historical_records.Stack
    const nowState = JSON.stringify($store.state.body.data)
    const Pointer = historical_records.Pointer
    const StateObj = {
      type: 0,
      name: name,
      time: new Date().getTime(),
      data: nowState
    }
    // debugger
    if (Stack.length === 0) {
      Stack.push(StateObj)
    } else {
      const StackLength = Stack.length
      const prevState = Stack[Pointer].data

      // 如果当前这次的状态和上一次不同
      if (nowState !== prevState) {
        // 如果当前已经撤销过了，再有新的状态进来，个嘛在当前状态之后可以被恢复的状态都要干掉
        // 指针不在模拟堆栈的最后一个，个嘛就是在撤销状态中
        if (Pointer < StackLength - 1) {
          Stack.splice(Pointer + 1)
        }
        Stack.push(StateObj)
        historical_records.Pointer++
        historical_records.is_change = true // 当前是被修改状态
        historical_records.hasUnsavedChange = true
        if (Stack.length > 100) {
          Stack.splice(0, 1)
          historical_records.Pointer--
        }
      }
    }
    // console.log('Pointer变化',$store.state.historical_records.Pointer);
  }

  undo() {
    const historical_records = $store.state.historical_records
    if (historical_records.Pointer <= 0) return
    const Stack = historical_records.Stack
    $store.commit('widgets/SET_module_Data', null)
    historical_records.Pointer--
    // 取出当前指针指向的那个状态
    const allData = JSON.parse(Stack[historical_records.Pointer].data)
    $store.commit('body/SET_data', allData)
    this.select_module_modify()
  }

  redo() {
    const historical_records = $store.state.historical_records
    const Stack = historical_records.Stack
    $store.commit('widgets/SET_module_Data', null)
    if (historical_records.Pointer >= Stack.length - 1) return
    historical_records.Pointer++;
    const allData = JSON.parse(Stack[historical_records.Pointer].data)
    $store.commit('body/SET_data', allData)
    this.select_module_modify()
  }

  // 撤销或恢复后，多选数组要同步一下，不然值不对了
  select_module_modify() {
    const arr = []
    const widgets = this.get_widgets()
    const select_module = $store.state.widgets.select_module
    for (let i = 0; i < select_module.length; i++) {
      for (let j = 0; j < widgets.length; j++) {
        if (select_module[i].tid === widgets[j].tid) {
          arr.push(widgets[j])
        }
      }
    }
    $store.state.widgets.select_module = arr
  }

  has_submit(cmpType = 'gsubmit') {
    const widgets = this.get_widgets()
    let has_submit = false
    for (let i = 0; i < widgets.length; i++) {
      if (widgets[i].cmpType === cmpType) {
        has_submit = true
        break
      }
    }
    return has_submit
  }

  // 保存
  p_save(option = {}) {
    if ($store.state.widgets.save_loading) return
    const data = $store.state.body.data
    if (data && data.pages) {
      const theme_id = $store.state.widgets.theme_id
      //   $store.commit('widgets/SET_save_loading', true)
      if (theme_id) {
        // 有id就是编辑作品
        this.data_update(undefined, option)
      } else {
        // 没有id就是新增作品,新增模板
        this.new_data_save(option)
      }
    }
  }

  // 新增作品/模板
  new_data_save(option) {
    const save_obj = this.create_save_obj(-1)
    // save_obj.status = 0;
    const role = $store.state.app.role
    let ticket
    if (role === 'works' && $store.state.app.appTag === 'zzyx') {
      save_obj.ticket = $store.state.app.ticket
      ticket = $store.state.app.ticket
    }
    console.log(save_obj, 'save_obj')
  }

  // 编辑作品/模板
  async data_update(status, option) {
    //  bin 更新作品的时候上传海报
    console.log('更新海报开始')
    //  let worksCover = await basics.updateWorkPoster().catch(_err => {
    //    console.log('更新海报失败');
    //  });
    $store.state.historical_records.hasUnsavedChange = false
    console.log('更新海报结束')
  }

  // 创建保存的对象
  create_save_obj(status) {
    const data = $store.state.body.data
    console.log('大json', $store.state.body.data)
    const template_upload = $store.state.widgets.template_upload
    const theme_info = $store.state.widgets.theme_info
    const role = $store.state.widgets.role
    const formList = this.create_formList()
    const lanternList = this.createLanternList()

    const obj = {
      content: JSON.stringify(data),
      page: data.pages.length
    }

    if (role === 'works') {
      obj.formList = formList
      obj.kongmingRuleReqs = lanternList
      obj.title = theme_info.title
      obj.coverUrl = theme_info.coverUrl
      obj.worksDesc = theme_info.worksDesc
      if ($store.state.widgets.appTag === 'zzyx' && status) {
        obj.worksDesc = '我用珍岛Marketingforce做了一个超炫酷的H5，快来看看吧~'
      }
    } else {
      if (typeof status === 'number' || typeof status === 'string') {
        obj.status = status
      }

      obj.templateDesc = template_upload.templateDesc
      obj.title = template_upload.title
      obj.style = template_upload.style
      obj.purpose = template_upload.purpose
      obj.industry = template_upload.industry
      obj.color = template_upload.color
      obj.coverUrl = template_upload.coverUrl
      obj.function = template_upload.function
      obj.holidays = template_upload.holidays
      obj.interact = template_upload.interact
    }
    return obj
  }

  create_formList() {
    const formList = []
    const data = $store.state.body.data
    const pages = data.pages
    const from = ['ginput', 'gchoose', 'gselect']
    // 创建表单数据
    for (let i = 0; i < pages.length; i++) {
      const one = {
        formId: pages[i].id,
        inputList: []
        //  name:pages[i].id,
      }
      if (pages[i].cmps && pages[i].cmps instanceof Array) {
        one.name = pages[i].cmps.find(curr => curr.cmpType === 'gsubmit')?.nickname || ' '
        for (let j = 0; j < pages[i].cmps.length; j++) {
          const module = pages[i].cmps[j]
          if (from.indexOf(module.cmpType) > -1) {
            const inp = {
              inputId: module.tid,
              inputTitle: module.nickname
            }
            one.inputList.push(inp)
          }
        }
      }
      formList.push(one)
    }
    // 删除没有input元素的表单
    for (let i = 0; i < formList.length; i++) {
      if (formList[i].inputList.length === 0) {
        formList.splice(i, 1)
        i--
      }
    }

    return formList
  }

  createLanternList() {
    const list = []
    const data = $store.state.body.data
    const pages = data.pages
    pages.cmps.forEach(module => {
      if (module.cmpType === 'lantern') {
        list.push({
          activityMode: module.activityMode,
          activityName: module.activityName,
          activityRule: module.activityRule,
          backgroundUrl: module.backgroundUrl,
          endDate: module.endDate,
          makeWishCount: module.makeWishCount,
          formId: module.tid,
          sponsor: module.sponsor,
          startDate: module.startDate,
          txtBlessing: module.txtBlessing
        })
      }
    })
    return list
  }
  // 保存用户端信息
  info_update(showTips = true) {
  }

  // 单页编辑
  one_page_update(option = {}) {
    const theme_id = $store.state.widgets.theme_id
    // $store.commit('widgets/SET_save_loading', true)
    if (theme_id) {
      // 有id就是编辑作品
      this.one_page_save(undefined, option)
    } else {
      // 没有id就是新增作品,新增单页
      $store.commit('widgets/SET_onepage_index', 0)
      this.create_new_page(undefined, option)
    }
  }

  one_page_save(status, option) {
  }

  // 新增单页
  create_new_page(status = -1, option) {
  }

  // 创建单页对象
  create_onePage_obj() {
    const data = JSON.parse(JSON.stringify($store.state.body.data))
    const page = data.pages
    if (page) {
      page.id = this.create_id()
      if (page.cmps && page.cmps instanceof Array) {
        for (let j = 0; j < page.cmps.length; j++) {
          page.cmps[j].tid = this.create_id()
        }
      }
      data.pages = page
    }
    return data
  }

  // 自动保存：只有在有新挂件加入的时候才会触发，加入后的3分钟之后触发。
  auto_save() {
    const timer = $store.state.widgets.auto_save_timer
    if (timer === null && !$store.state.widgets.demonstrationTag) {
      $store.state.widgets.auto_save_timer = setTimeout(() => {
        this.auto_save_make()
      }, 180000)
    }
  }
  auto_save_make() {
    const save_pattern = $store.state.widgets.save_pattern
    if (save_pattern === 'imagetext') {
      if ($store.state.widgets.theme_id) {
        return this.save_imagetext()
      }
      return
    }
    if (save_pattern === 'page') {
      // 单页保存
      this.one_page_update({
        needToast: false
      })
    } else {
      this.p_save({
        needToast: false
      })
    }
    // console.log('自动保存')
  }

  clear_auto_save() {
    clearTimeout($store.state.widgets.auto_save_timer)
    $store.state.widgets.auto_save_timer = null
  }

  color_change(module) {
    const u_svg = $(`#u${module.tid} .svg_frame`).find('svg')
    const v_svg = $(`#v${module.tid} .svg_frame`).find('svg')
    const fill = module.fill
    for (let i = 0; i < fill.length; i++) {
      u_svg.find('path').eq(i).attr('fill', fill[i])
      v_svg.find('path').eq(i).attr('fill', fill[i])
      u_svg.find('polygon').eq(i).attr('fill', fill[i])
      v_svg.find('polygon').eq(i).attr('fill', fill[i])
    }
  }

  to_preview() {
    $store.commit('widgets/SET_save_function', () => {
      // 保存的回调函数，保存成功后会执行
      // 打开预览窗口
      $store.commit('widgets/SET_preview_dialog', true)

      // 值重置
      $store.commit('widgets/SET_save_function', null)
    })

    // 直接掉保存接口
    this.auto_save_make()
  }

  moudle_rotate_methods(module) {
    const btn = module.find('.rotate_icon_btn')
    const that = this
    btn[0].onmousedown = function(e) {
      const module_top = module[0].getBoundingClientRect().top
      const module_left = module[0].getBoundingClientRect().left
      const module_width = module.width()
      const module_height = module.height()
      const origin_x = module_left + module_width / 2
      const origin_y = module_top + module_height / 2
      const module_Data = $store.state.widgets.module_Data
      let angle_init_val = 0
      if (module_Data && module_Data.style) {
        angle_init_val = module_Data.style.rotate
      }
      let angle = 0
      if (angle_init_val) angle = 0
      $('.one_rotate_line').remove()
      that.create_rotate_line(module)
      document.onmousemove = function(ev) {
        ev.preventDefault()
        // let angle = 0;
        const x = ev.pageX
        const y = ev.pageY

        // 右上角
        if (y <= origin_y && x >= origin_x) {
          const a = origin_y - y
          const b = x - origin_x
          const c = Math.sqrt(a * a + b * b)
          angle = (Math.asin(b / c) * 180) / Math.PI
        } else if (y >= origin_y && x >= origin_x) {
          // 右下角
          const a = y - origin_y
          const b = x - origin_x
          const c = Math.sqrt(a * a + b * b)
          angle = (Math.asin(a / c) * 180) / Math.PI + 90
        } else if (y >= origin_y && x <= origin_x) {
          // 左下角
          const a = y - origin_y
          const b = origin_x - x
          const c = Math.sqrt(a * a + b * b)
          angle = (Math.asin(b / c) * 180) / Math.PI + 180
        } else if (y <= origin_y && x <= origin_x) {
          // 左上角
          var a = origin_y - y
          var b = origin_x - x
          var c = Math.sqrt(a * a + b * b)
          angle = (Math.asin(a / c) * 180) / Math.PI + 270
        }

        // 角度吸附
        if (angle <= 4 || angle >= 356) angle = 0
        else if (angle <= 49 && angle >= 41) angle = 45
        else if (angle <= 94 && angle >= 86) angle = 90
        else if (angle <= 139 && angle >= 131) angle = 135
        else if (angle <= 189 && angle >= 176) angle = 180
        else if (angle <= 229 && angle >= 221) angle = 225
        else if (angle <= 274 && angle >= 266) angle = 270
        else if (angle <= 319 && angle >= 311) angle = 315
        module.find('.relativeFrame').css('transform', `rotate(${angle}deg)`)
      }
      document.onmouseup = function() {
        $('.one_rotate_line').remove()
        document.onmousemove = null
        document.onmouseup = null

        // 设置数值
        if (!$store.state.widgets.module_Data) return
        $store.state.widgets.module_Data.style.rotate = Number(angle.toFixed(2))
      }
    }
  }

  // 产出对齐线
  create_rotate_line(module) {
    const w = module.width()
    const h = module.height()
    for (let i = 0; i < 4; i++) {
      const line = $(`<div class="one_rotate_line one_rotate_line_${i + 1}"></div>`)
      const size = w > h ? w : h
      line.css({ width: size + 160 + 'px' })
      line.appendTo(module)
    }
  }

  // 平移
  module_translation(direction, num) {
    const select_module = $store.state.widgets.select_module
    for (let i = 0; i < select_module.length; i++) {
      const module = select_module[i]
      if (!module.lock) {
        module.style[direction] = module.style[direction] + num
      }
    }
  }

  // 置于顶层/置于底层
  move_layer(type) {
    const select_module = $store.state.widgets.select_module
    if (select_module.length === 1) {
      const module = select_module[0]
      if (!module.lock) {
        const index = this.p_find_module_index(module.tid) //  在widgets数组中的顺序
        const widgets = this.get_widgets()
        // 如果到顶，或到底则不能继续操作了
        if (type === 'up' && index === widgets.length - 1) return
        if (type === 'down' && index === 0) return

        const handle_module = widgets.splice(index, 1)[0] //  先删除被选中的元素，然后push到数组里。意思数组中越往后越置顶？
        if (type === 'up') {
          widgets.splice(index + 1, 0, handle_module)
        } else if (type === 'top') {
          widgets.splice(widgets.length, 0, handle_module) //  相当于push
        } else if (type === 'down') {
          widgets.splice(index - 1, 0, handle_module)
        } else if (type === 'bottom') {
          widgets.splice(0, 0, handle_module)
        }
        console.log(widgets, 'widgets')
      }
    }
  }

  // 全选
  select_all() {
    const data = $store.state.body.data
    if (data && data.pages) {
      const pages = data.pages
      const modules = pages.cmps
      if (modules && modules.length > 0) {
        for (let i = 0; i < modules.length; i++) {
          $store.commit('widgets/ADD_select_module', modules[i])
        }
      }
    }
  }

  screen_line_align_start() {
    const select_module = $store.state.widgets.select_module

    let min_s_l = 99999 // 距离屏幕左边最小的距离
    let min_s_t = 99999 // 距离屏幕上边最小的距离
    let max_s_r = 0 // 右边距离屏幕左边最大的值
    let max_s_b = 0 // 下边距离屏幕上边最大的值

    let top_id = ''
    let left_id = ''
    let right_id = ''
    let bottom_id = ''

    // let min_bottom = 0;
    // 找出多选挂件的最左边
    for (let i = 0; i < select_module.length; i++) {
      const module = select_module[i]
      const dom = $(`#u${module.tid}`)[0]
      const l = dom.getBoundingClientRect().left
      const t = dom.getBoundingClientRect().top
      const r = dom.getBoundingClientRect().right
      const b = dom.getBoundingClientRect().bottom

      if (l < min_s_l) {
        min_s_l = l
        left_id = module.tid
      }

      if (t < min_s_t) {
        min_s_t = t
        top_id = module.tid
      }

      if (r > max_s_r) {
        max_s_r = r
        right_id = module.tid
      }

      if (b > max_s_b) {
        max_s_b = b
        bottom_id = module.tid
      }
    }
    const end = {
      top_id, // 最上面的id
      left_id, // 最左面的id
      right_id, // 最右面面的id
      bottom_id, // 最下面面的id
      width: max_s_r - min_s_l,
      height: max_s_b - min_s_t
    }
    // $store.state.align.modules_size = end;
    return end
  }

  // 多选/单选挂件，屏幕对齐
  screen_line_align_move(moveLeft, moveTop, $this) {
    const modules_size = $store.state.align.modules_size
    const frame_rect = $('#layout_body')[0].getBoundingClientRect()

    this.all_direction_align('top')
    this.all_direction_align('bottom')
    this.all_direction_align('left')
    this.all_direction_align('right')

    // 左右居中
    if (modules_size.width && modules_size.left_id) {
      const frame_center = frame_rect.left + frame_rect.width / 2
      const left = $(`#u${modules_size.left_id}`)[0].getBoundingClientRect().left
      const move_center = left + modules_size.width / 2
      if (parseInt(frame_center) === parseInt(move_center)) {
        $store.commit('lock_transverse_true')
        this.p_create_line({
          type: 'vertical',
          size: frame_rect.height + 40,
          top: frame_rect.top - 20,
          left: frame_rect.left + frame_rect.width / 2
        })
      }
    }

    // 上下居中
    if (modules_size.height && modules_size.top_id) {
      const frame_center = frame_rect.top + frame_rect.height / 2
      const top = $(`#u${modules_size.top_id}`)[0].getBoundingClientRect().top
      const move_center = top + modules_size.height / 2
      if (parseInt(frame_center) === parseInt(move_center)) {
        $store.commit('lock_vertical_true')
        this.p_create_line({
          type: 'transverse',
          size: frame_rect.width + 40,
          top: frame_rect.top + frame_rect.height / 2,
          left: frame_rect.left - 20
        })
      }
    }

    this.p_lock(moveLeft, moveTop, $this)
  }

  // 上下左右对齐
  all_direction_align(type) {
    const modules_size = $store.state.align.modules_size
    const frame_rect = $('#layout_body')[0].getBoundingClientRect()
    const id = modules_size[`${type}_id`]
    if (id) {
      const val = $(`#u${id}`)[0].getBoundingClientRect()[type]
      if (parseInt(val) === parseInt(frame_rect[type])) {
        if (type === 'top' || type === 'bottom') {
          $store.commit('lock_vertical_true')
          this.p_create_line({
            type: 'transverse',
            size: frame_rect.width + 40,
            top: frame_rect[type],
            left: frame_rect.left - 20
          })
        } else if (type === 'left' || type === 'right') {
          $store.commit('lock_transverse_true')
          this.p_create_line({
            type: 'vertical',
            size: frame_rect.height + 40,
            top: frame_rect.top - 20,
            left: frame_rect[type]
          })
        }
      }
    }
  }

  // 批量锁定
  module_locks(type) {
    const select_module = $store.state.widgets.select_module
    for (let i = 0; i < select_module.length; i++) {
      const dom = $(`#u${select_module[i].tid}`)
      const moduleId = dom.attr('id')
      const val = parseFloat(dom.css(type))
      const style = $(`<style class="lock_${type}_style">#${moduleId} {${type}:${val}px !important;}</style>`)
      style.appendTo('head')
    }
  }
  bg_wrapper_top() {
    let top = ($store.state.body.data.height - 748) / 2
    if (top > 0) top = 0
    return top
  }

  save_imagetext() {
  }

  get_imagetext_detail(data) {
  }

  applyVariable(pages, isSinglePage) {
    if (!Array.isArray(pages)) {
      pages = [pages]
    }
    if (!$store.state.body.data.varApplied || isSinglePage) {
      const hasVar = pages.some(p => {
        return p.cmps.some(m => m.var)
      })
      if (hasVar) {
        this.doApplyVariable(pages)
      }
    }
  }

  doApplyVariable(pages) {
    const data = $store.state.body.companyDetail
    if (!data) {
      return
    }
    const keysChangeText = ['name', 'introduction', 'phone', 'email', 'address']
    const keysChangeImageUrl = ['logo', 'wechatQrcode', 'gzhQrcode']
    pages.forEach(p => {
      return p.cmps.forEach(m => {
        if (keysChangeText.includes(m.var)) {
          if (data[m.var]) {
            m.text = data[m.var]
          }
        }
        if (keysChangeImageUrl.includes(m.var)) {
          if (data[m.var]) {
            m.file.orikey = data[m.var]
            m.file.key = data[m.var]
          }
          utils.fixImgSize(data[m.var], m)
        }
        if (m.var === 'videos') {
          const videos = data[m.var]?.split(',') || []
          if (videos[m.varIndex]) {
            m.video.vo_url = videos[m.varIndex]
          }
        }
        if (m.var === 'pics') {
          const pics = data[m.var]?.split(',') || []
          if (pics[m.varIndex]) {
            m.file.orikey = pics[m.varIndex]
            m.file.key = pics[m.varIndex]
            utils.fixImgSize(pics[m.varIndex], m)
          }
        }
        if (m.var === 'prodPics') {
          const prodPics = JSON.parse(data[m.var]) // ?.split(',') || []
          if (prodPics[m.varIndex] && m.cmpType === 'image') {
            m.file.orikey = prodPics[m.varIndex].url
            m.file.key = prodPics[m.varIndex].url
            utils.fixImgSize(prodPics[m.varIndex], m)
          }
          if (prodPics[m.varIndex] && m.cmpType === 'text') {
            m.text = prodPics[m.varIndex].name
          }
        }
      })
    })
  }
}
